import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";

const AvailabilitySetModal = ({
  show,
  onHide,
  value = "",
  onSave,
  isApplyPage = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedOption, setSelectedOption] = useState("");
  const [error, setError] = useState("");

  const availabilityOptions = [
    { value: "true", label: "Yes, availability has been set" },
    { value: "false", label: "No, availability not set" },
  ];

  // Load existing value
  // useEffect(() => {
  //   if (!show) return;

  //   const current = store?.profileItem?.data?.nurseProfile?.availability_set;

  //   if (current !== undefined && current !== null) {
  //     setSelectedOption(String(current));
  //   }
  // }, [show, store?.profileItem]);
  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      // ✅ Apply page
      setSelectedOption(value !== undefined ? String(value) : "");
    } else {
      // ✅ Profile page
      const current = store?.profileItem?.data?.nurseProfile?.availability_set;

      if (current !== undefined && current !== null) {
        setSelectedOption(String(current));
      }
    }

    // ❗ ONLY depend on show
  }, [show]);

  const handleSelect = (value) => {
    setSelectedOption(value);
    setError("");
  };

  // const handleSave = () => {
  //   if (!selectedOption) {
  //     setError("Please select an option");
  //     return;
  //   }

  //   const formData = new FormData();

  //   formData.append(
  //     "name",
  //     store?.profileItem?.data?.name ||
  //       store?.profileItem?.data?.full_name ||
  //       "",
  //   );

  //   formData.append("availability_set", selectedOption);

  //   dispatch(updateProfile(formData));
  // };
const handleSave = () => {
  if (selectedOption === "") {
    setError("Please select an option");
    return;
  }

  const finalValue = selectedOption === "true";

  if (isApplyPage) {
    // ✅ LOCAL
    onSave(finalValue);
    onHide();
  } else {
    // ✅ API
    const formData = new FormData();

    formData.append(
      "name",
      store?.profileItem?.data?.name ||
        store?.profileItem?.data?.full_name ||
        ""
    );

    formData.append("availability_set", finalValue);

    dispatch(updateProfile(formData));
  }
};
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Have you set your availability?</h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {availabilityOptions.map((option) => (
              <div
                key={option.value}
                className={`radio-option col-lg-6 ${
                  selectedOption === option.value ? "selected" : ""
                }`}
                onClick={() => handleSelect(option.value)}
              >
                <div className="contentwrap">
                  <input
                    type="radio"
                    checked={selectedOption === option.value}
                    readOnly
                  />

                  <label className="radio-label">{option.label}</label>
                </div>
              </div>
            ))}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || !selectedOption}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AvailabilitySetModal;
